import type { FaireProductEntity } from "../../entity_types/product";

export const p_jk9dr3pyx2: FaireProductEntity = {
  token: "p_jk9dr3pyx2",
  type: "product",
  name: "Spooky Cute Squishy",
  brandToken: "b_ajcvx3qqyh",
  brandName: "Hustle & Heart Boutique",
  imageUrl:
    "https://cdn.faire.com/fastly/3674f72973ecaa17e40d0f8a22e062b77db600369ac69a4dceac1cfa4ec27909.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0c1ff526a80a50915406ac6be9d33ad97d9769273e487f5f4df4a6c8b4b5b3dc.jpeg",
    "https://cdn.faire.com/fastly/418b3019e6f48e09d025024ef2a21067448d24104d65ce62e08a4930a653f49d.jpeg",
    "https://cdn.faire.com/fastly/b53a29721f2f2afb83cb64bbb9060d070df15298d3893e4ddfcbda2e420b403b.jpeg",
    "https://cdn.faire.com/fastly/74fc0447ed0cf55b154522116b98b7929c15a9a8ffe40839603d29c1a7bec56f.jpeg",
    "https://cdn.faire.com/fastly/927f44ad952feb3b67d451d8d61658cef5f631c35e3c799ae604f727adf39ffc.jpeg",
  ],
  priceDollars: 12,
  description:
    "When you order $500 worth of squishys that have this in the bio your order gets sent directly to you for shorter shipping time, along with other squishy orders that you place. \n\nWho said it was too early for Halloween? Look how cute these are!! Do wait till till last min get these early so your the first one with them on the shelves this fall \n\nPlease allow 3-8 weeks once order is placed. If order is big enough yours will be shipped straight to YOU. If not it will ship with other orders that are placed EVERY FRIDAY",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:45.219Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
